module.exports = __webpack_public_path__ + "static/media/Server Down.2b0fb742.png";